import { FeedAnalysis } from '@modules/feed/components/FeedContainerIndex/FeedAnalysis';
import { useInitSearchStoreFromSearchParams } from '@modules/feed/hooks';
import { useFeedStore } from '@modules/feed/store/feedStore';
import { SearchActionType } from '@modules/feed/store/searchActionType';
import { getFeedQueryRetentionKey } from '@modules/feed/utils';
import { isQueryParamsPresentInURL } from '@modules/feed/utils/isQueryParamsPresentInURL';
import { useFeedSessionStorage } from '@modules/quantify/hooks/useFeedSessionStorage';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useGetUser } from 'v2/core/services/user';

export function NewFeedAnalysis() {
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useFeedStore(({ dispatch }) => dispatch);
  const { setFeedStoreFromSessionStorage, setSessionStorageFromFeedStore } =
    useFeedSessionStorage();

  useInitSearchStoreFromSearchParams();

  useEffect(() => {
    if (!isQueryParamsPresentInURL()) {
      setFeedStoreFromSessionStorage();
    }
  }, [setFeedStoreFromSessionStorage]);

  useEffect(() => {
    return () => {
      setSessionStorageFromFeedStore();
    };
  }, [setSessionStorageFromFeedStore]);

  const resetSearchParam = searchParams.get('reset');

  useEffect(() => {
    if (resetSearchParam === 'true') {
      sessionStorage.removeItem(getFeedQueryRetentionKey(tenantSlug));
      dispatch({
        type: SearchActionType.RESET,
      });
      setSearchParams({});
    }
  }, [dispatch, resetSearchParam, setSearchParams, tenantSlug]);

  return <FeedAnalysis />;
}
